import { useContext } from "react";
import FieldDashboardContext from "./FieldDashboardContext";

function useFieldDashboard() {
    return useContext(FieldDashboardContext);
}

export default useFieldDashboard;
